import PartnerNav from '@lexus.com/ui/dist/components/PartnerNav';
export default PartnerNav;
